import { authContext } from "indexApp"
import axios from "axios"

const actionList = ['UPDATE', 'SET_ALL_CONSTS', 'INIT', 'UPDATE_CONFIG']

// Initialize config from localStorage to ensure values are available immediately
const getInitialConfig = () => {
  const configKeys = ['LOGITRAC_API_URL', 'REACT_APP_ADAL_TENANTID', 'REACT_APP_ADAL_CLIENTID']
  const config = {}
  configKeys.forEach(key => {
    const value = localStorage.getItem(key)
    if (value) config[key] = value
  })
  return config
}

export const initialState = {
  reset: true,
  constsArrays: null,
  constsObjs: null,
  user: '',
  currentTerminal: '',
  config: getInitialConfig()
}

const actions = actionList.reduce((list, action) => ({ ...list, [action]: action }), {})

export const actionGenerators = {
  update: payload => ({ type: actions.UPDATE, payload }),
  setAllConsts: payload => ({ type: actions.SET_ALL_CONSTS, payload }),
  init: payload => ({ type: actions.INIT, payload }),
  updateConfig: payload => ({ type: actions.UPDATE_CONFIG, payload })
}


const handlers = {
  [actions.UPDATE]: (state, { payload }) => ({ ...state, ...payload }),
  [actions.UPDATE_CONFIG]: (state, { payload }) => ({ ...state, config: { ...state.config, ...payload } }),
  [actions.SET_ALL_CONSTS]: (state, { payload: { constants } }) => {
    const constCategories = constants.reduce((acc, cur) => ({ ...acc, [cur.category]: [...(acc[cur.category] ? acc[cur.category] : []), cur] }), {})
    const constsArrays = constants.reduce((acc, { category, type }) => ({ ...acc, [category]: [...(acc[category] ? acc[category] : []), type] }), {})
    const constsObjs = Object.fromEntries(Object.entries(constsArrays).map(([key, val]) => [key, val.reduce((acc, cur, ind) => ({ ...acc, [ind]: cur }), {})]))
    return ({ ...state, constsArrays, constsObjs, constCategories })
  },
  [actions.INIT]: (state, { payload: { constants: { constants }, allUsers: { allUsers }, reset } }) => {
    const constCategories = constants.reduce((acc, cur) => ({ ...acc, [cur.category]: [...(acc[cur.category] ? acc[cur.category] : []), cur] }), {})
    const constsArrays = constants.reduce((acc, { category, type }) => ({ ...acc, [category]: [...(acc[category] ? acc[category] : []), type] }), {})
    const constsObjs = Object.fromEntries(Object.entries(constsArrays).map(([key, val]) => [key, val.reduce((acc, cur, ind) => ({ ...acc, [ind]: cur }), {})]))
    const { profile: { oid, family_name, given_name }, userName } = authContext.getCachedUser()
    const [existingUser] = allUsers.filter(user => user.email.toLowerCase() === userName.toLowerCase())

    if (existingUser) {
      return { ...state, reset, constsArrays, constsObjs, constCategories, user: existingUser, allUsers, currentTerminal: existingUser?.current_terminal ? existingUser?.current_terminal : existingUser.terminals[0] ? existingUser.terminals[0] : '' }
    } else {
      const dbUser = { email: userName, first_name: given_name, last_name: family_name, permissions: '{}', terminals: '{}', id: oid }
      const user = { email: userName, first_name: given_name, last_name: family_name, permissions: [], terminals: [], id: oid }
      try {
        axios.post(
          `${localStorage.getItem("LOGITRAC_API_URL")}api/insert`,
          {
            item: dbUser,
            dbTable: "users",
            dbEvent: "insert",
            dbUserId: oid
          }
        )
      } catch (error) {
        console.log('error: ', error);
      }

      return { ...state, reset, constsArrays, constsObjs, constCategories, user, allUsers }
    }
  }
}

export const reducer = (state = initialState, action) => {
  return handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state
}